import { RaceBy } from "@uiball/loaders";
import Flexbox from "./Flexbox";
import Mode from "./styles/Mode";
import { useSelector } from "react-redux";

const Loading = () => {
    const mode = useSelector(state => state.darkmode.value)

    return (
        <Mode>
            <div className="loading-component">
                <Flexbox justifyContent="center" alignItems="center" style={{ height: '90dvh', width: '100%' }}>
                    <RaceBy size={40} speed={0.9} color={mode.dark ? "white" : "black"} />
                </Flexbox>
            </div>
        </Mode>
    );
}

export default Loading;